import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationView} from './UIGamePlayerInformationView'
import {AnimatedSpriteView} from '../../ui_canvas_engine/AnimatedSpriteView'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'

export class UIGamePlayerInformationWaitIconView implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly playerInformation: UIGamePlayerInformationView
    private readonly waitIcon?: AnimatedSpriteView

    constructor(uiGameManager: UIGameManager, playerInformation: UIGamePlayerInformationView) {
        this.uiGameManager = uiGameManager
        this.playerInformation = playerInformation

        this.uiGameManager.eventController.registerUIGameMechanic(this)

        const isMyColor = this.uiGameManager.gameController.myColor == playerInformation.player.color
        const waitIconWidth = isMyColor ? this.playerInformation.specialIconView.height * 0.85 : this.playerInformation.specialIconView.width * 0.85
        const sheetName = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI ? 'game_spritesheet_wait_icon_mobile' : 'game_spritesheet_wait_icon'
        const sheet = UIGameSpriteHandler.getSpritesheet(sheetName)
        if(sheet == undefined) return
        const firstTexture = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI ? sheet.textures['waitIcon_mobile_01.png'] : sheet.textures['waitIcon_01.png']
        const waitIconHeight = firstTexture.height / firstTexture.width * waitIconWidth
        this.waitIcon = new AnimatedSpriteView(0, 0, waitIconWidth, waitIconHeight, this.playerInformation.specialIconView, sheet.animations['waitIcon'])
        this.waitIcon.animationSpeed = 0.25
        if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb) this.waitIcon.scale.set(0.75)
        this.onPlayerStateUpdates()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.TradeStateUpdated:
            case UIGameEventEnums.PlayerControllerStateUpdated: this.onPlayerStateUpdates(); break
            default: break
        }
    }

    private onPlayerStateUpdates() {
        const isPlayerTakingAction = this.uiGameManager.gameController.gameValidator.isPlayerTakingOutOfTurnAction(this.playerInformation.player.color)
        isPlayerTakingAction ? this.showIcon() : this.hideIcon()
    }

    private showIcon() {
        if(this.waitIcon == undefined) return
        if(this.waitIcon.playing) return

        this.waitIcon.play()
        this.playerInformation.specialIconView.addSpriteView(this.waitIcon)
    }

    private hideIcon() {
        if(this.waitIcon?.parent == undefined) return

        this.waitIcon.stop()
        this.playerInformation.specialIconView.removeSpriteView(this.waitIcon)
    }

    destroy() {
        this.uiGameManager.eventController.unregisterUIGameMechanic(this)
    }
}
